import { sectionsResource } from './sections.js';
import { termsResource } from './terms.js';
import {
    selectInstructorSections,
    selectInstructorSectionsTerms,
} from '../selectors/section';

export function instructorResourceDefinition() {
    return {
        all_terms: options => termsResource(options),
        all_sections: {
            depends: ['all_terms'],
            all_sections(options, all_terms) {
                return sectionsResource(
                    options,
                    all_terms.reduce(
                        (accum, t) => accum.concat(t.section_ids),
                        []
                    )
                );
            },
        },
        sections: {
            depends: ['all_sections'],
            sections(options, all_sections) {
                return () => selectInstructorSections(options.rootState);
            },
        },
        terms: {
            depends: ['all_terms', 'sections'],
            terms(options, all_terms, sections) {
                return () => selectInstructorSectionsTerms(options.rootState);
            },
        },
    };
}



// WEBPACK FOOTER //
// ./src/resources/instructorResourceDefinition.js